import { ArrowRightIcon, ClipboardCheckIcon, InfoOutlineIcon, PendingIcon } from '@components'
import { useOnboardingAction } from '@hooks'
import cn from '@integrations/classnames'
import { OnboardingActions, OnboardingStatuses, useMerchantQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import Banner from './Banner'

interface Props {
  className?: string
}

const ActionArrow = <ArrowRightIcon color='currentColor' opacity='1' />

function OnboardingBanner({ className = '' }: Props) {
  const { merchant } = useMerchantQry()

  const { onboardingAction, startOrContinueOnboarding } = useOnboardingAction()

  switch (onboardingAction) {
    case OnboardingActions.NOT_STARTED:
    case OnboardingActions.ONBOARDING:
      if (merchant?.onboardingStatus === OnboardingStatuses.APPROVED_EXPIRING_DOCUMENT) {
        return (
          <Banner
            className={cn(className)}
            icon={<ClipboardCheckIcon />}
            title={tr('FRONTEND.ONBOARDING.EXPIRING_DOCUMENT.HEADING', 'Expiring document')}
            content={tr(
              'FRONTEND.ONBOARDING.EXPIRING_DOCUMENT.MESSAGE',
              'Your document is expiring, upload newer one to avoid limitation of services.'
            )}
            handleClick={startOrContinueOnboarding}
            actionLabel={tr('FRONTEND.ONBOARDING.EXPIRING_DOCUMENT.BUTTON', 'Upload document')}
            actionIcon={ActionArrow}
            actionTestId='button-onboarding-banner'
            dataTest='onboarding-banner'
          />
        )
      }
      return (
        <Banner
          className={cn(className)}
          icon={<ClipboardCheckIcon />}
          title={tr('FRONTEND.ONBOARDING.COMPLETE_TITLE', 'Complete your account')}
          content={tr(
            'FRONTEND.ONBOARDING.COMPLETE_TEXT',
            'Verify to get access to all features and increased payment limits.'
          )}
          handleClick={startOrContinueOnboarding}
          actionLabel={tr('FRONTEND.ONBOARDING.COMPLETE_BUTTON', 'Verify account')}
          actionIcon={ActionArrow}
          actionTestId='button-onboarding-banner'
          dataTest='onboarding-banner'
        />
      )

    case OnboardingActions.DOCUMENTS:
      //todo
      break

    case OnboardingActions.QUESTIONNAIRE:
      return (
        <Banner
          className={cn(className)}
          icon={<ClipboardCheckIcon />}
          title={tr('FRONTEND.ONBOARDING.QUESTIONNAIRE.HEADING', 'Complete the questionnaire')}
          content={tr(
            'FRONTEND.ONBOARDING.QUESTIONNAIRE.MESSAGE',
            'Complete the questionnaire in order to proceed with the account onboarding'
          )}
          handleClick={() => startOrContinueOnboarding()}
          actionLabel={tr('FRONTEND.ONBOARDING.QUESTIONNAIRE.BUTTON', 'Complete questionnaire')}
          actionIcon={ActionArrow}
          actionTestId='button-onboarding-banner'
          dataTest='onboarding-banner'
        />
      )

    case OnboardingActions.APPLICATION_FEE:
      //todo
      break

    case OnboardingActions.UNDER_REVIEW:
      return (
        <Banner
          className={cn(className)}
          icon={<PendingIcon />}
          content={tr('FRONTEND.ONBOARDING.UNDER_REVIEW_MESSAGE', 'Your account verification is under review.')}
          dataTest='onboarding-banner'
        />
      )

    default:
      if (merchant?.onboardingStatus === OnboardingStatuses.REJECTED_FINAL) {
        return (
          <Banner
            className={cn(className)}
            icon={<InfoOutlineIcon />}
            content={tr(
              'FRONTEND.ONBOARDING.REJECTED_MESSAGE',
              'Please contact Customer Service to get support on your account verification.'
            )}
            dataTest='onboarding-banner'
          />
        )
      }
  }

  return null
}

export default OnboardingBanner
